<template>
    <div class="account">
        <div class="top_header_fixed">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/materialList' }">物料</el-breadcrumb-item>
                <el-breadcrumb-item>{{ headerTitle }}</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="title_btn">
                <div>
                    <el-button size="small" plain @click="insert">新增</el-button>
                    <el-button size="small" plain @click="copy">复制</el-button>
                    <el-button size="small" plain @click="update">编辑</el-button>
                    <el-button size="small" plain @click="del">删除</el-button>
                    <draggableDetail :draggable="{ data_name: 'material' }" @isErrshow="reload"></draggableDetail>
                </div>
            </div>
        </div>
        <div class="main_list">
            <el-collapse v-model="activeNames">
                <el-collapse-item disabled title="基本信息" name="1">
                    <el-form label-position="right" :model="data" class="details" label-width="auto">
                        <template>
                            <el-row v-for="(item_out, index_out) in colData" :key="index_out">
                                <el-col :span="12" v-for="(item, index) in item_out" :key="index">
                                    <el-form-item :label="item.title ? item.title + '：' : ''">
                                        <div
                                            class="read_only read_only_link"
                                            v-if="
                                                (item.prop == 'material_type_name' && data['material_type_rid'] != '') ||
                                                (item.prop == 'dedicated_product_name' && data['dedicated_product_rid'] != '') ||
                                                (item.prop == 'dedicated_product_licence_name' &&
                                                    data['dedicated_product_licence_rid'] != '')
                                            "
                                        >
                                            <span @click="toDetail(item.prop)">{{ data[item.prop] }}</span>
                                        </div>
                                        <el-input
                                            v-else
                                            v-model="data[item.prop]"
                                            class="flex_item_text"
                                            size="mini"
                                            readonly="readonly"
                                        ></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </template>
                    </el-form>
                </el-collapse-item>
            </el-collapse>
        </div>
    </div>
</template>
<script>
import { onDelete, processColumnDataToRowNew } from '@/js/common';
import draggableDetail from '../../../common/DrawerDetail.vue';

export default {
    inject: ['reload'],
    name: 'materialDetail',
    components:{
        draggableDetail
    },
    data() {
        return {
            colData: [],
            activeNames: ['1'],
            data: {},
            queryParams: {},
            headerTitle: '物料详情'
        };
    },
    watch: {
        $route(to, from) {
            this.queryParams.rid = to.query.id;
            this.reload();
        }
    },
    beforeMount() {
        this.selectedColData(); //筛选列
        this.initQueryParams();
    },
    mounted() {
        this.$nextTick(() => {
            this.getData(); //获取详情
        });
    },
    methods: {
        toDetail(prop) {
            if (prop == 'material_type_name') {
                this.$router.push({
                    path: '/materialTypeDetail',
                    query: {
                        id: this.data.material_type_rid
                    }
                });
            } else if (prop == 'dedicated_product_name') {
                this.$router.push({
                    path: '/productListDetails',
                    query: {
                        id: this.data.dedicated_product_rid
                    }
                });
            } else if (prop == 'dedicated_product_licence_name') {
                this.$router.push({
                    path: '/productDetails',
                    query: {
                        id: this.data.dedicated_product_licence_rid
                    }
                });
            }
        },
        initQueryParams() {
            this.queryParams.rid = this.$route.query.id;
        },
        //筛选列
        selectedColData() {
            let colData = JSON.parse(localStorage.getItem('detailList')).material;
            processColumnDataToRowNew(colData, this);
        },
        //删除
        del() {
            onDelete(this.data.id, this, 'materialDelete', this.data.name, 'materialList');
        },
        //编辑
        update() {
            this.$router.push({
                path: 'materialEdit',
                query: {
                    type: 'update',
                    id: this.data.rid
                }
            });
        },
        //新增
        insert() {
            this.$router.push({
                path: 'materialEdit',
                query: {
                    type: 'insert'
                }
            });
        },
        //复制
        copy() {
            this.$router.push({
                path: 'materialEdit',
                query: {
                    type: 'copy',
                    id: this.data.rid
                }
            });
        },
        //详情
        getData() {
            this.$api
                .materialDetail(this.queryParams)
                .then((res) => {
                    this.data = res.data;
                    document.title = this.headerTitle + ':' + res.data.code;
                })
                .catch((error) => {});
        }
    }
};
</script>
<style lang="scss" scoped="scoped">
</style>